module.exports = __webpack_public_path__ + "static/media/suber2.f5c3ec1c.png";